<template>
  <div>
    <button
      v-if="listing.status === 'active'"
      type="button"
      class="btn btn-primary btn-sm"
      :disabled="togglingStatus"
      @click="toggleStatus('sold')"
    >
      Mark as Sold
    </button>
    <button
      v-else
      type="button"
      class="btn btn-primary btn-sm"
      :disabled="togglingStatus"
      @click="toggleStatus('active')"
    >
      Mark as Available
    </button>
  </div>
</template>

<script>
export default {
  name: 'MarkAsSold',
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      togglingStatus: false,
    };
  },
  methods: {
    async toggleStatus(newStatus) {
      this.togglingStatus = true;

      const method = 'PATCH';
      const url = `posts/${this.listing.id}/`;
      const body = {
        type: this.listing.type,
        category: this.listing.category,
        title: this.listing.title,
        description: this.listing.description,
        price: this.listing.price,
        images: this.listing.images,
        status: newStatus,
      };

      const responseData = await this.api({
        url,
        method,
        json: body,
      });

      this.togglingStatus = false;

      if (responseData.status === 200) {
        this.$emit('newStatus', newStatus);
      } else {
        alert(
          `Unable to Mark as ${newStatus}. Please check your `
          + 'connection and try again.',
        );
      }
    },
  },
};
</script>
